import { businessAreaSettings } from "./businessAreaSettings";

export const hideCheckboxes = (): boolean => {  
  return (
    businessAreaSettings().hideBulkAssign &&
    businessAreaSettings().hideBulkClaim &&
    businessAreaSettings().hideBulkClassify &&
    businessAreaSettings().hideBulkClose
  );
};